module.exports = __webpack_public_path__ + "ipad-air-gold@2x.png?19f7e0bc6da4440a939168ea6c4abe08";